import { Bar, BarChart, CartesianGrid, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const redColor = "#f87171";
const greenColor = "#34d399";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ background: "#fff", padding: "10px", border: "1px solid #ccc" }}>
        <p><strong>{label}</strong></p>
        <p style={{ color: greenColor }}>Entrants: {payload[0].value}</p>
        <p style={{ color: redColor }}>Sortants: {payload[1].value}</p>
      </div>
    );
  }
  return null;
};

export default function InOutClientsChart({ data }) {

  return (
    <div style={{ width: "100%", height: 400 }}>
      <ResponsiveContainer>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="month" />
          <YAxis label={{ value: "Nombre de clients", angle: -90, position: "insideLeft" }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend verticalAlign="bottom" iconType="square" height={36} />

          <Bar dataKey="new" fill={greenColor} name="Entrants" radius={[6, 6, 0, 0]}>
            <LabelList dataKey="new" position="top" fill={greenColor} />
          </Bar>
          <Bar dataKey="old" fill={redColor} name="Sortants" radius={[6, 6, 0, 0]}>
            <LabelList dataKey="old" position="top" fill={redColor} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
